// import logo from './logo.svg';
// import './App.css';
import '@khmyznikov/pwa-install';

function showInstall(e){
  // e.preventDefault();
  e.stopPropagation();

  var pwaInstall = document.getElementsByTagName('pwa-install')[0];
  pwaInstall.showDialog()
}

function App() {
  return (
    <div className="App">
      <pwa-install
        use-local-storage="false"

        install-description="Install NodeSeek Pwa"
        disable-install-description="true"
        disable-screenshots="true"
        disable-screenshots-apple="true"
        disable-screenshots-chrome="true"

        disable-android-fallback="true"

        // name="PWA"
        // description="Progressive web application"         
        // icon="/icon.png"
        >
      </pwa-install>
      <button onClick={showInstall}>安装</button>
    </div>
  );
}

export default App;
